function Service() {
  // Dynamic data list (add more cards easily later)
  const services = [
    {
      img: 'img/Balacany_net.png',
      title: 'Balcony Bird Netting',
      desc: 'Durable UV-resistant nets to keep pigeons away from balconies safely.',
      delay: '0',
    },
    {
      img: 'img/Invisible_Grill.png',
      title: 'Invisible Grill Netting',
      desc: 'Protect warehouses, factories, and open spaces with industrial-grade nets.',
      delay: '150',
    },
    {
      img: 'img/Bird_Spike.png',
      title: 'Pigeon Spikes Installation',
      desc: 'Prevent birds from perching on ledges, roofs, and window sills effectively.',
      delay: '300',
    },
  ];

  return (
    <>
      <section className='container py-4 px-5' id='service'>
        <h2 className='text-center mb-4' data-aos='fade-up'>
          Our Bird Netting Solutions
        </h2>

        <div className='row g-3'>
          {services.map((item, index) => (
            <div
              key={index}
              className='col-12 col-md-4'
              data-aos='zoom-in'
              data-aos-delay={item.delay}
            >
              <div className='card service-card border-0 text-center shadow-sm h-100'>
                <img
                  src={item.img}
                  alt={item.title}
                  loading='lazy'
                  className='card-img-top img-thumbnail'
                />
                <div className='card-body'>
                  <h5>{item.title}</h5>
                  <p>{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Service;
